package pl.decks.personal.pages.ievp.foreword

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import pl.decks.personal.components.layouts.site.SiteLayoutStylesheet
import pl.decks.personal.extensions.toSitePalette
import pl.decks.personal.pages.ievp.IEVPStylesheet
import pl.decks.personal.styles.SiteLayout

private val NOTES = listOf(
    "Fluent in differential equations, with a heavy-tailed, Lévy accent",
    "Comfortable when the data is noisy",
    "Not new to pharma: experiment design, and data put to work accelerating Phase III trials",
    "A trail of scientific research turned into tested, integrated software (one saved a million for Nokia)",
    "Concept to clinic, owned end to end - pipelines, platform and product",
    "Privacy-obsessed, in how I operate and how I handle data",
    "Always shaping the role to what is missing from the team",
)

@OptIn(DelicateApi::class)
@Composable
fun TinyPharmaForeword() = Column(
    modifier = SiteLayoutStylesheet.Page.Content.toModifier()
        .padding(left = IEVPStylesheet.Vars.contentPaddingLeft.value(), top = SiteLayout.Space.Medium)
        .gap(SiteLayout.Space.Small)
        .setVariable(ForewordStylesheet.Vars.pointBackgroundColor, ColorMode.current.toSitePalette().surface)
        .setVariable(ForewordStylesheet.Vars.pointVisitedBackgroundColor, ColorMode.current.toSitePalette().accents.primary)
        .setVariable(ForewordStylesheet.Vars.pointStrokeColor, ColorMode.current.toSitePalette().accents.primary),
    horizontalAlignment = Alignment.CenterHorizontally,
) {
    CoverLetterText(
        "The world's wonder starts at the smallest scale. Life has evolved mechanisms that solve problems we do not fully understand. Many times we merely rediscover what is already done - error correction, redundancy, fault tolerance... Even hacking. Mathematics teases a world with clean answers, but with biology, whenever you manage to open a lid, myriad new questions pop out. Humankind might never get to the final one and it's a thrilling prospect.",
        "You squeeze your approach into three words: \"RenTech of pharma\". The company didn't hire traders - it went for mathematicians and physicists to treat the market as a problem to model, not a club to join. If you aspire to the same principles, if you wager on advantage built by compounding knowledge from various minds in a central repository, then the outsider is by design.",
        "So, I'm no biologist. I've spent my career translating between domains, speaking math to science, science to software, software to data, and back around. Give me a start on the computational half of the work and the biology will follow.",
        "The helix holds because two strands pair. Here is mine:",
    )
    val breakpoint = rememberBreakpoint()
    val (segments, height) = if (breakpoint < Breakpoint.MD) 2 to 140.0 else 3 to 200.0
    val pointsPerSegment = 6
    val takenRungs = remember(segments) {
        (0 until segments * pointsPerSegment).shuffled().take(NOTES.size).sorted()
    }
    NotesHelix(
        segments = segments,
        pointsPerSegment = pointsPerSegment,
        notes = takenRungs.zip(NOTES).toMap(),
        helixHeight = height,
        mainStrainColor = ColorMode.current.toSitePalette().accents.primary,
        secondaryStrainColor = ColorMode.current.toSitePalette().accents.secondary,
    )
}
